module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.imageUrl) ? _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "rotate_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.imageUrl)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.imageUrl)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.imageUrl)
      }
    }
  })])])]) : _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box felx_"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "50px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "felx_"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.hideQR
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076ffe27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/components/image.vue
// module id = d3yK
// module chunks = 6